<template>
  <div class="card-item">
    <div class="left">
      <img class="pic" :src="item.picture" :alt="item.title" />
    </div>
    <div class="right">
      <div class="content-box">
        <div class="title" v-html="highlightKeyword(item.title)"></div>
        <div class="desc" v-html="highlightKeyword(item.description)"></div>
      </div>
      <div class="status-box">
        <div class="status-txt" :style="{ 'background-color': upBgColor, color: upFontColor }">{{ statusTxt }}</div>
        <div class="progess-box">
          <span class="txt">{{ upTxt }}</span>
          <div class="rate" :style="{ width: `${progress}%`, 'background-color': upBgColor }"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "@/plugins/dayjs";

export default {
  name: "CardItem",
  props: {
    item: {
      type: Object,
      required: true
    },
    searchKey: {
      type: String,
      default: ""
    },
    kindName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      progress: 0
    };
  },
  computed: {
    statusTxt() {
      const currentTime = Date.now();
      if (this.item.begin_at * 1000 > currentTime) return "未开始";
      if (this.item.end_at * 1000 < currentTime) return "已结束";
      return "进行中";
    },
    upTxt() {
      const currentTime = Date.now();
      if (this.item.begin_at * 1000 > currentTime)
        return `${dayjs.unix(this.item.begin_at).format("YYYY/MM/DD")}-${dayjs
          .unix(this.item.end_at)
          .format("YYYY/MM/DD")}`;
      if (this.item.end_at * 1000 < currentTime)
        return `${dayjs(this.item.begin_at * 1000).format("YYYY/MM/DD")}-${dayjs(this.item.end_at * 1000).format(
          "YYYY/MM/DD"
        )}`;
      const diff = this.item.end_at * 1000 - currentTime;
      return `还剩${Math.floor(dayjs.duration(diff).asDays())}天${dayjs.duration(diff).hours()}小时`;
    },
    upBgColor() {
      const currentTime = Date.now();
      if (this.item.begin_at * 1000 > currentTime) return "var(--zs-kc-carditem-progress-bg-color)";
      if (this.item.end_at * 1000 < currentTime) return "var(--zs-kc-carditem-complete-bg-color)";
      return "var(--zs-kc-carditem-doing-bg-color)";
    },
    upFontColor() {
      const currentTime = Date.now();
      if (this.item.begin_at * 1000 > currentTime) return "var(--zs-kc-carditem-progress-font-color)";
      if (this.item.end_at * 1000 < currentTime) return "var(--zs-kc-carditem-complete-color)";
      return "var(--zs-kc-carditem-doing-color)";
    }
  },
  mounted() {
    const currentTime = Date.now();
    if (this.item.begin_at * 1000 > currentTime) {
      this.progress = 0;
    }
    if (this.item.end_at * 1000 < currentTime) {
      this.progress = 100;
    }
    this.progress = this.getProgress(this.item.begin_at, this.item.end_at);
  },
  methods: {
    /**
     * 接收两个参数，start_at和end_at，均为秒级时间戳，与当前时间对比，返回一个进度值
     */
    getProgress(start_at, end_at) {
      const now = Date.now() / 1000;
      if (now < start_at) {
        return 0;
      }
      if (now > end_at) {
        return 100;
      }
      return ((now - start_at) / (end_at - start_at)) * 100;
    },
    highlightKeyword(text) {
      if (!this.searchKey) return text;
      const regex = new RegExp(`(${this.searchKey})`, "g");
      const highlightedText = text.replace(regex, `<span class="__highlight-search-key__">$1</span>`);
      return highlightedText;
    }
  }
};
</script>
<style>
.__highlight-search-key__ {
  color: red;
}
</style>
<style lang="less" scoped>
.card-item {
  box-sizing: content-box;
  height: 80px;
  display: flex;
  padding: 28px 0;
  border-bottom: 1px solid var(--zs-kc-tab-bottom-border-color);
  .left {
    width: 190px;
    display: flex;
    align-items: center;
    gap: 15px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    .pic {
      border-radius: 8px;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .right {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 16px;
    width: 0;
    .content-box {
      .title {
        font-size: 14px;
        color: var(--zs-kc-hd-title-color);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .desc {
        font-size: 12px;
        color: var(--zs-kc-carditem-role-desc-color);
        margin-top: 6px;
        // 最多显示3行
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
    .status-box {
      display: flex;
      gap: 6px;
      .status-txt {
        width: 72px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        font-size: 11px;
        border-radius: 10px;
      }
      .progess-box {
        flex-grow: 1;
        width: 0;
        height: 16px;
        position: relative;
        border-radius: 8px;
        background-color: var(--zs-kc-carditem-progress-bg-color);
        overflow: hidden;
        .txt {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 11px;
          color: var(--zs-kc-carditem-progress-font-color);
          z-index: 1;
        }
        .rate {
          position: absolute;
          height: 100%;
          left: 0;
          width: 50%;
        }
      }
    }
  }
}
</style>
